if (!customElements.get('product-form')) {
  function getCartAddJsonUrl() {
    const u = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (u.includes('.js')) return u;
    return u.replace(/(\/cart\/add)(?=\?|#|$)/, '$1.js');
  }

  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      if (this._shopifyProductFormInit) return;
      this._shopifyProductFormInit = true;

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) {
        idInput.removeAttribute('disabled');
        idInput.disabled = false;
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) {
        idInput.removeAttribute('disabled');
        idInput.disabled = false;
      }

      const variantId = parseInt(idInput && idInput.value, 10);
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const rawQty = (quantityInput && quantityInput.value) || '1';
      const quantity = Math.max(1, parseInt(rawQty, 10) || 1);

      if (!variantId) {
        this.handleErrorMessage(
          (window.cartStrings && window.cartStrings.error) || 'Select a product option before adding to cart.'
        );
        return;
      }

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      this.error = false;

      const lineItem = { id: variantId, quantity: quantity };
      if (window.PlatiniOrderSource) {
        const journey = window.PlatiniOrderSource.getJourney
          ? window.PlatiniOrderSource.getJourney()
          : [];
        const clickSrc = window.PlatiniOrderSource.resolve
          ? window.PlatiniOrderSource.resolve(this.submitButton || this)
          : '';
        if (clickSrc && journey.indexOf(clickSrc) === -1) journey.push(clickSrc);
        if (journey.length) {
          lineItem.properties = lineItem.properties || {};
          lineItem.properties._src = journey.join(', ');
        }
      }
      const body = { items: [lineItem] };
      if (window.PlatiniOrderSource && typeof window.PlatiniOrderSource.getTagsString === 'function') {
        const tags = window.PlatiniOrderSource.getTagsString();
        if (tags) {
          body.attributes = {
            src_tags: tags,
            _src_tags: tags,
          };
        }
      }
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      fetch(getCartAddJsonUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || response.message);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            document.dispatchEvent(
              new CustomEvent('cart:item-added', { bubbles: true, detail: { response } })
            );
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { response } })
          );
        })
        .catch((e) => {
          console.error(e);
          this.error = true;
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const s = this.querySelector('.loading-overlay__spinner');
          if (s) s.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
